// store/selectors/feedbackSelectors.ts
import type { RootState } from "../index";

export const selectFeedbackMessage = (state: RootState) => state.feedback.message;
export const selectFeedbackIsSubmitting = (state: RootState) => state.feedback.isSubmitting;
export const selectFeedbackIsSubmitted = (state: RootState) => state.feedback.isSubmitted;
export const selectFeedbackError = (state: RootState) => state.feedback.error;
